import { ApiQuery, Namespace, Query } from './types';

/**
 * 将前端查询参数转换为 API 查询参数
 *
 * 转换规则：
 * - page * size → _offset
 * - size → _limit
 * - sort → _sort (如果 T 中包含 sort 字段)
 * - 其他字段保持不变
 */
export function toApiQuery<T extends Record<string, any> = Record<string, any>>(
  query: Query<T>
): ApiQuery<T> {
  const { page, size, sort, ...rest } = query as Query<T> & { sort?: any };

  const result: any = {
    _limit: size,
    _offset: page !== undefined && size !== undefined ? page * size : undefined,
    ...rest,
  };

  // 如果存在 sort 字段，转换为 _sort
  if (sort !== undefined) {
    result._sort = sort;
  }

  return result as ApiQuery<T>;
}

/**
 * 获取所有命名空间并返回键值对映射
 * @param key {string} 可选的命名空间 key 前缀过滤
 * @returns {Record<string, Namespace>} 命名空间键值对映射
 */
export function buildNamespaceMap(namespaces: Namespace[]): Record<string, Namespace> {
  const map: Record<string, Namespace> = {};
  namespaces.forEach((ns) => {
    map[ns.key] = ns;
  });
  return map;
}
